import {
  Label as AriaLabel,
  type LabelProps as AriaLabelProps,
} from 'react-aria-components';
import clsx from 'clsx';

/** React Aria `Label`; associates itself with the field it sits in. */
export function Label({ className, ...rest }: AriaLabelProps) {
  const classes = clsx('label text-base-content', className);
  return <AriaLabel {...rest} className={classes} />;
}
